import {
  CHINESE_CATEGORY_ALIASES,
  DEFAULT_CIP_CHEMICALS,
} from "../../constants/global.constants";
import { CHEMICAL_FIELDS_KEYS } from "./config";

const getChemicalById = (category, plantChemicalLibrary) => {
  const defaultChemId = DEFAULT_CIP_CHEMICALS[category].chem_id;
  const chemInLibrary = plantChemicalLibrary.find(
    (chem) => chem.chem_id === defaultChemId,
  );

  const { display_name, price } = chemInLibrary || {};

  return {
    chemical_name: display_name || "",
    price: price || 0,
  };
};

export const getInitialChemicalSelection = (plantChemicalLibrary) => {
  const defaultChemicalSelection = {
    acid: {
      chem_id: DEFAULT_CIP_CHEMICALS.ACID.chem_id,
      ...getChemicalById("ACID", plantChemicalLibrary),
    },
    alkali: {
      chem_id: DEFAULT_CIP_CHEMICALS.ALKALI.chem_id,
      ...getChemicalById("ALKALI", plantChemicalLibrary),
    },
    additional_chemical: {
      chem_id: DEFAULT_CIP_CHEMICALS.SOLUTION.chem_id,
      ...getChemicalById("SOLUTION", plantChemicalLibrary),
    },
  };

  return defaultChemicalSelection;
};

const normalizeChemicalCategory = (category) => {
  if (!category) return "";
  const normalizedCategory = category.toLowerCase().trim();
  return CHINESE_CATEGORY_ALIASES[normalizedCategory] || normalizedCategory;
};

export const getChemicalOptionsByCategory = (chemicalLibrary) => {
  if (!chemicalLibrary || chemicalLibrary.length === 0) return {};
  const chemicalOptions = CHEMICAL_FIELDS_KEYS.reduce((acc, key) => {
    const sourceCategory = key === "additional_chemical" ? "solution" : key;
    acc[key] = chemicalLibrary
      .filter(
        (item) => normalizeChemicalCategory(item.category) === sourceCategory,
      )
      .map((item) => ({
        label: item.display_name,
        value: item.chem_id,
        price: item.price,
      }));
    return acc;
  }, {});
  return chemicalOptions;
};
